import { useNavigate } from 'react-router-dom';
import {
  Container, Title, Text, Card, Group, ThemeIcon,
  SimpleGrid, Stack, Button, Box, Divider, UnstyledButton,
} from '@mantine/core';
import {
  IconBook2, IconArrowLeft, IconChecklist,
  IconUser, IconCalendar, IconClipboard, IconListCheck,
  IconMapPin,
} from '@tabler/icons-react';

const CATEGORY = {
  title: 'Acts Care Courses',
  icon: IconBook2,
  color: 'blue',
  description: '5 lookups in this category',
};

const LOOKUPS = [
  {
    title: 'Course Status',
    description: 'Active, Inactive, Completed states for courses',
    icon: IconChecklist,
    link: '/LookUp/ActsCareCourses/CourseStatus',
  },
  {
    title: 'Facilitator Status',
    description: 'Availability states for course facilitators',
    icon: IconUser,
    link: '/LookUp/ActsCareCourses/FacilitatorStatus',
  },
  {
    title: 'Session Status',
    description: 'Scheduled, In Progress, Done states',
    icon: IconCalendar,
    link: '/LookUp/ActsCareCourses/SessionStatus',
  },
  {
    title: 'Session Progress Status',
    description: 'Track participant progress through sessions',
    icon: IconListCheck,
    link: '/LookUp/ActsCareCourses/SessionProgressStatus',
  },
  {
    title: 'Registration Status',
    description: 'Pending, Approved, Cancelled registrations',
    icon: IconClipboard,
    link: '/LookUp/ActsCareCourses/RegistrationStatus',
  },
];

const ALL_CATEGORIES = [
  { label: 'Acts Care Courses', icon: IconBook2,  link: '/LookUp/ActsCareCourses',   active: true },
  { label: 'Acts Care Counseling', icon: IconUser, link: '/LookUp/ActsCareCounseling', active: false },
  { label: 'Locations', icon: IconMapPin,  link: '/LookUp/Location', active: false  },
];

export default function ActsCareCourseIndexPage() {
  const navigate = useNavigate();

  return (
    <Container size="xl" py="xl">
      <Group align="flex-start" gap="xl" wrap="nowrap">
        {/* ── Sidebar ─────────────────────────────── */}
        <Box w={220} style={{ flexShrink: 0 }}>
          <Button
            variant="subtle"
            leftSection={<IconArrowLeft size={14} />}
            mb="lg"
            px={0}
            onClick={() => navigate('/LookUp')}
          >
            All Lookups
          </Button>

          <Text size="xs" fw={700} tt="uppercase" c="dimmed" mb="sm">
            Categories
          </Text>

          <Stack gap={4}>
            {ALL_CATEGORIES.map((cat) => (
              <UnstyledButton
                key={cat.label}
                onClick={() => navigate(cat.link)}
                style={(theme) => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  padding: '8px 10px',
                  borderRadius: theme.radius.sm,
                  backgroundColor: cat.active
                    ? theme.colors.blue[9] + '33'
                    : 'transparent',
                  color: cat.active ? theme.colors.blue[4] : theme.colors.gray[4],
                  fontWeight: cat.active ? 600 : 400,
                })}
              >
                <ThemeIcon
                  variant={cat.active ? 'light' : 'subtle'}
                  color={cat.active ? 'blue' : 'gray'}
                  size="sm"
                  radius="sm"
                >
                  <cat.icon size={14} />
                </ThemeIcon>
                <Text size="sm">{cat.label}</Text>
              </UnstyledButton>
            ))}
          </Stack>
        </Box>

        <Divider orientation="vertical" />

        {/* ── Main panel ──────────────────────────── */}
        <Box style={{ flex: 1 }}>
          <Group gap="md" mb={4}>
            <ThemeIcon variant="light" color="blue" size="lg" radius="md">
              <IconBook2 size={18} />
            </ThemeIcon>
            <div>
              <Title order={3}>{CATEGORY.title}</Title>
              <Text size="sm" c="dimmed">{CATEGORY.description}</Text>
            </div>
          </Group>

          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" mt="lg">
            {LOOKUPS.map((lookup) => (
              <Card
                key={lookup.title}
                shadow="sm"
                padding="lg"
                radius="md"
                withBorder
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(lookup.link)}
              >
                <Group gap="sm" wrap="nowrap">
                  <ThemeIcon variant="light" color="blue" size="md" radius="md">
                    <lookup.icon size={14} />
                  </ThemeIcon>
                  <div>
                    <Text fw={600} size="sm">{lookup.title}</Text>
                    <Text size="xs" c="dimmed">{lookup.description}</Text>
                  </div>
                </Group>
              </Card>
            ))}
          </SimpleGrid>
        </Box>
      </Group>
    </Container>
  );
}